import { render, staticRenderFns } from "./Enemy.vue?vue&type=template&id=73999c0a&"
import script from "./Enemy.vue?vue&type=script&lang=ts&"
export * from "./Enemy.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports